export const I18N_RESOURCE = {
    cn: {
        LTLTools: {
            tabs: {
                tracking: "零担/整车/平板车物流跟踪",
                moving: "长途搬家服务",
                consignee: "收货人详情",
            },
            search: {
                label: "请输入",
                placeholder: "例如: 12345678",
                button: {
                    track: "查询",
                    consignee: "查看收货信息",
                },
                error: "查询出错，请检查单号是否正确或稍后再试。",
                noData: "未查询到相关追踪信息。",
                results: {
                    status: "状态",
                    lastUpdate: "最后更新时间",
                    deliveryDateNA: "暂无数据",
                    detailsTitle: "追踪详情"
                },
                types: {
                    bol: "提单号 (BOL)",
                    pro: "PRO 单号",
                    pickup: "取货确认号",
                    confirmationCode: "确认码",
                    tracking: "包裹追踪号码",
                }
            },
            consignee: {
                heading: "收货详情",
                companyName: "公司名称",
                consigneeName: "收货人姓名",
                email: "电子邮箱",
                phone: "联系电话",
                address: "详细地址",
                city: "城市",
                province: "省/州",
                postalCode: "邮政编码",
                country: "国家",
                appointmentDeliverDate: "预约送达日期",
                deliverLocationOpenTime: "营业开始时间",
                deliverLocationCloseTime: "营业结束时间",
                appointmentDeliverName: "收货人姓名",
                appointmentDeliverPhone: "收货电话",
                button: '更新',
                successMessage: '成功更新收货详情',
                errorMessage: '更新收货详情失败',
                require: '必填',
                invalid: '无效',
                feeDialog: {
                    title: "重要提示：可能产生额外费用",
                    content: "修改配送日期或时间可能会触发额外费用（预计 $50 - $200）。原因可能是产生二次预约，或导致仓储时间超过 2 天。",
                    subContent: "*具体收费原因和金额由承运商核定。",
                    confirm: "我已知晓并确认",
                    cancel: "取消"
                }
            }
        },
        captcha: {
            check: "安全检查：请完成下方验证以继续",
            loading: "正在验证您的安全环境..."
        }
    },
    en: {
        LTLTools: {
            tabs: {
                tracking: "LTL/FTL/Flatbed Tracking",
                moving: "Long-Distance Moving",
                consignee: "Consignee Details",
            },
            search: {
                label: "Enter",
                placeholder: "e.g. 12345678",
                button: {
                    track: "Track",
                    consignee: "Get Consignee Details",
                },
                error: "An error occurred during the inquiry. Please verify the number or try again later.",
                noData: "No tracking information found for the provided number.",
                results: {
                    status: "Status",
                    lastUpdate: "Last Updated",
                    deliveryDateNA: "N/A",
                    detailsTitle: "Tracking Details"
                },
                types: {
                    bol: "BOL #",
                    pro: "PRO #",
                    pickup: "Pickup Confirmation #",
                    confirmationCode: "Confirmation Code",
                    tracking: "Parcel Tracking #",
                }
            },
            consignee: {
                heading: "Consignee Details",
                heading2: "Appointment Details",
                companyName: "Company Name",
                consigneeName: "Consignee Name",
                email: "Email Address",
                phone: "Phone Number",
                address: "Address",
                city: "City",
                province: "Province",
                postalCode: "Postal Code",
                country: "Country",
                appointmentDeliverDate: "Appointment Delivery Date",
                deliverLocationOpenTime: "Open Time",
                deliverLocationCloseTime: "Close Time",
                appointmentDeliverName: "Deliver Name",
                appointmentDeliverPhone: "Deliver Phone",
                button: 'Update',
                successMessage: 'Successfully Updated Consignee Details.',
                errorMessage: 'Failed to Update Consignee Details.',
                require: 'require',
                invalid: 'invalid',
                feeDialog: {
                    title: "Important: Potential Extra Fees",
                    content: "Updating delivery date or time may trigger additional charges (est. $50 - $200) due to re-delivery or storage exceeding 2 days.",
                    subContent: "*Final fees are determined by the carrier.",
                    confirm: "Confirm & Proceed",
                    cancel: "Cancel"
                }
            }
        },
        captcha: {
            check: "Security Check: Please complete the verification below to continue",
            loading: "Verifying your security environment..."
        }
    }
};

export const getI18nContent = (lng, moduleName) => {
    const safeLng = I18N_RESOURCE[lng] ? lng : 'en';
    return I18N_RESOURCE[safeLng][moduleName] || I18N_RESOURCE['en'][moduleName];
};